/* eslint-disable no-unused-vars */
import { useAppContext } from "@context/app";
import Router from "next/router";
import { useEffect, useState } from "react";
import { consumeAuthRedirect, isAuthPath } from "@utils/authRedirect";

export const forwardAuthenticated = (
  __isAuthenticated: boolean,
  __redirectUrl: string
) => {
  if (__isAuthenticated) {
    const target = isAuthPath(Router.pathname)
      ? consumeAuthRedirect(__redirectUrl)
      : __redirectUrl;
    Router.replace(target);
  }
  return !__isAuthenticated;
};

export const forwardNotAuthenticated = (
  __isAuthenticated: boolean,
  __redirectUrl: string
) => {
  if (!__isAuthenticated) {
    Router.replace(__redirectUrl);
  }
  return __isAuthenticated;
};

interface pageProps {
  children: any;
  redirectUrl: string;
  noLayoutMode?: boolean;
  redirectHandler: (
    __isAuthenticated: boolean,
    __redirectUrl: string
  ) => boolean;
}

const Auth: React.FC<pageProps> = ({
  children,
  redirectUrl,
  redirectHandler,
  noLayoutMode = false,
}) => {
  const {
    user: { isLoggedIn, isLayoutLoaded },
  } = useAppContext();
  const [shouldRenderChildren, setShouldRenderChildren] =
    useState<boolean>(false);

  useEffect(() => {
    if (isLayoutLoaded || noLayoutMode)
      setShouldRenderChildren(redirectHandler(isLoggedIn, redirectUrl));
  }, [isLoggedIn, isLayoutLoaded]);

  if (shouldRenderChildren) {
    return <>{children}</>;
  }
  return <></>;
};

export default Auth;
